export const VIEW_MODE = {
  EXEMONE: 'exemone',
  MAXGAUGE: 'maxgauge',
  INTERMAX: 'intermax',
  CLOUDMOA: 'cloudmoa',
} as const;

// define.ts 와 동일하지만 import 문제 때문에 별도 선언
export const DB_TYPE = {
  NONE: 'NONE', // BE에 추가됨
  JAVA: 'java', // BE에 추가됨
  ORACLE: 'oracle',
  SQLSERVER: 'sqlserver',
  MYSQL: 'mysql',
  POSTGRESQL: 'postgresql',
  MONGODB: 'mongodb',
  REDIS: 'redis',
  CUBRID: 'cubrid',
  ALTIBASE: 'altibase',
  TIBERO: 'tibero',
  CLICKHOUSE: 'clickhouse',
  REDSHIFT: 'redshift',
  SINGLESTORE: 'singlestore',
} as const;

export const OS_TYPE = {
  WINDOWS: 'windows',
  Linux: 'linux',
  AIX: 'aix',
  HP_UX: 'hpux',
  CENTOS: 'centos',
  REDHAT: 'redhat',
  ROCKY: 'rocky',
  UBUNTU: 'ubuntu',
  DEBIAN: 'debian',
  SUSE: 'suse',
  FEDORA: 'fedora',
  SUNOS: 'sunos',
  UNKNOWN: 'unknown',
};

export const PLATFORM = {
  INFRA: 'infrastructure',
  MESSAGE_QUEUE: 'messageQueue',
  KUBE: 'kubernetes',
  WEB_SERVER: 'webServer',
  APP: 'application',
  DB: 'database',
  CLOUD: 'cloud',
} as const;

export const FILTER_PLATFORM = {
  APPLICATION: 'application',
  AWS_DMS: 'aws_dms',
  AWS_DOCUMENTDB: 'aws_documentdb',
  AWS_DYNAMODB: 'aws_dynamodb',
  AWS_EC2: 'aws_ec2',
  AWS_ELASTICACHE: 'aws_elastiCache',
  AWS_LAMBDA: 'aws_lambda',
  AWS_REDSHIFT: 'aws_redshift',
  AWS_S3: 'aws_s3',
  BUSINESS: 'business_service',
  CLOUD: 'cloud',
  CLOUD_COMPUTING: 'cloud_computing',
  CLOUD_DATABASE: 'cloud_database',
  CLOUD_STORAGE: 'cloud_storage',
  CONTAINER_HOST: 'container_host',
  DATABASE: 'database',
  GPU: 'gpu',
  HOST: 'host',
  KAFKA: 'kafka',
  NAMESPACE: 'namespace',
  ROUTE: 'route',
  NETWORK_DEVICE: 'network_device',
  NETWORK_OBJECT: 'network_object',
  RUM: 'rum',
  URL: 'url',
  WEBSERVER: 'webserver',
  OBJECT_TOPOLOGY: 'object_topology',
  COST_EXPLORER: 'cost-explorer',
  LOGGING: 'logging',
  ALERT: 'alert',
  DASHBOARD_EXPORT: 'dashboardExport',
  PREDEFINED_REPORT: 'predefinedReport',
  PREDEFINED_REPORT_EXPORT: 'predefinedReportExport',
} as const;

export const MAXGAUGE_MODE_TARGET_LIST = ['database', 'host'] as const;

export const INTERMAX_MODE_TARGET_LIST = ['host', 'application', 'messageQueue'] as const;

export const LOGIN_CUSTOMER = {
  EXEMONE: 'EXEMONE',
  HYUNDAICAPITAL: 'HYUNDAICAPITAL',
  HYUNDAICARD: 'HYUNDAICARD',
  KAKAOBANK: 'KAKAOBANK',
  LGE: 'LGE',
  MONIMO: 'MONIMO',
  NONGHYUP: 'NONGHYUP',
  SHINHANBANK: 'SHINHANBANK',
} as const;

export const SERVER_TAG_SEPARATOR = 'ect_::_';

export const OBJECT = {
  HOST: 'host',
  NETWORK_DEVICE: 'network_device',
  NETWORK_OBJECT: 'network_object',
  MESSAGE_QUEUE: 'message_queue',
  CLOUD_GROUP: 'cloud_group',
  CLUSTER: 'cluster',
  NODE: 'node',
  NAMESPACE: 'namespace',
  WAS: 'was',
  WEBSERVER: 'webserver',
  ORACLE: 'oracle',
  MYSQL: 'mysql',
  POSTGRESQL: 'postgresql',
  MONGODB: 'mongodb',
  REDIS: 'redis',
  ALTIBASE: 'altibase',
  CUBRID: 'cubrid',
  SQLSERVER: 'sqlserver',
  TIBERO: 'tibero',
  CLICKHOUSE: 'clickhouse',
  REDSHIFT: 'redshift',
  SINGLESTORE: 'singlestore',
} as const;

export const QM_STAT_FRONT_VERSION = '3.0.505.15';

export const CHART_Y_LABEL_FIX_WIDTH = 40;

export const PA_TOGGLE_DATA_TYPE = {
  SUM: 'sum',
  AVG: 'avg',
  MAX: 'max',
} as const;

export const ALERT_PLATFORM_TYPES = {
  APPLICATION: 'application',
  AWS_DMS: 'awsDms',
  AWS_DOCUMENT_DB: 'awsDocumentDB',
  AWS_DYNAMO_DB: 'awsDynamoDB',
  AWS_EC2: 'awsEC2',
  AWS_ELASTICACHE: 'awsElasticache',
  AWS_LAMBDA: 'awsLambda',
  AWS_REDSHIFT: 'awsRedshift',
  AWS_S3: 'awsS3',
  AZURE_FUNCTIONS: 'azureFunctions',
  AZURE_VIRTUAL_MACHINES: 'azureVirtualMachines',
  AZURE_BLOB_STORAGE: 'azureBlobStorage',
  AZURE_COSMOS_DB: 'azureCosmosDB',
  AZURE_CACHE_FOR_REDIS: 'azureCacheForRedis',
  BUSINESS: 'business',
  CLUSTER: 'cluster',
  CONTAINER: 'container',
  CRONJOB: 'cronjob',
  DAEMONSET: 'daemonset',
  DATABASE: 'database',
  DATABASE_CLUSTER: 'database_cluster',
  DEPLOYMENT: 'deployment',
  GPU: 'gpu',
  HOST: 'host',
  HPA: 'hpa',
  JOB: 'job',
  KAFKA: 'kafka',
  KAFKA_CLUSTER: 'kafka_cluster',
  KAFKA_BROKER: 'kafka_broker',
  LOGS: 'logs',
  NAMESPACE: 'namespace',
  NETWORK_DEVICE: 'networkDevice',
  NETWORK_OBJECT: 'networkObject',
  NODE: 'node',
  OPENSHIFT_ROUTE: 'route',
  POD: 'pod',
  PERSISTENT_VOLUME_CLAIM: 'persistentVolumeClaim',
  REPLICASET: 'replicaset',
  RUM: 'rum',
  SERVICE: 'service',
  STATEFULSET: 'statefulset',
  URL: 'url',
  WEBSERVER: 'webserver',
} as const;
